var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.43,
    height: 119.22,
    viewBox: "0 0 127.43 119.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fcdd42;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.64,31.88,64.44,1.25a5.31,5.31,0,0,0-6.85,0L2.43,47.92A6.88,6.88,0,0,0,0,53.16v62a4.06,4.06,0,0,0,4.06,4.06H123.37a4.06,4.06,0,0,0,4.06-4.06V54a4.06,4.06,0,0,0-4.06-4H106.82a3.75,3.75,0,0,1-3.75-3.75h0V37.12A6.88,6.88,0,0,0,100.64,31.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14,111.61a.8.8,0,0,1-.9-.68.81.81,0,0,1,0-.22V88.23a.8.8,0,0,1,.69-.9.74.74,0,0,1,.21,0h9.78A1.09,1.09,0,0,1,20,88l4.51,8.78h.1L29.19,88a1.13,1.13,0,0,1,1.08-.66h9a.8.8,0,0,1,.9.69.74.74,0,0,1,0,.21v22.48a.8.8,0,0,1-.69.9H32.14a.8.8,0,0,1-.9-.68.81.81,0,0,1,0-.22V100h-.1l-4.4,8.25a1.14,1.14,0,0,1-1.08.62H22.75a1.18,1.18,0,0,1-1.08-.66L17.3,99.92h-.14v10.79a.8.8,0,0,1-.69.9.74.74,0,0,1-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,111.61a.8.8,0,0,1-.9-.68.81.81,0,0,1,0-.22V104L42.27,88.41a.72.72,0,0,1-.05-.76.77.77,0,0,1,.71-.31h9A1.11,1.11,0,0,1,53,88l3.4,7.87h.1L59.72,88a1,1,0,0,1,1-.69h8.53a.7.7,0,0,1,.69.31.77.77,0,0,1-.07.76L61.2,104.16v6.56a.8.8,0,0,1-.69.9H51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05,104.15h11a.8.8,0,0,1,.9.69.74.74,0,0,1,0,.21v5.65a.8.8,0,0,1-.69.9.74.74,0,0,1-.21,0H73a.8.8,0,0,1-.9-.68.81.81,0,0,1,0-.22V88.22a.8.8,0,0,1,.69-.9h8.4a.8.8,0,0,1,.9.69.74.74,0,0,1,0,.21v15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.46,109q-3.3,3.15-9.33,3.14T98.8,109q-3.3-3.14-3.29-9.42c0-4.19,1-7.32,3.14-9.47s5.25-3.23,9.49-3.23,7.36,1.08,9.47,3.23,3.16,5.31,3.16,9.47-1.1,7.32-3.29,9.42Zm-9.33-3.07a2,2,0,0,0,2.13-1.47,16.78,16.78,0,0,0,.5-4.94,17.51,17.51,0,0,0-.5-4.94A2,2,0,0,0,108.13,93,2.09,2.09,0,0,0,106,94.55a16.72,16.72,0,0,0-.52,4.93,17.48,17.48,0,0,0,.5,4.94,2.06,2.06,0,0,0,2.17,1.47Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/logo_yellow.a23cea7298d22a3a236aec8c3eb8e889.svg";
export { ForwardRef as ReactComponent };